<div class="card-container">
    <div class="between-center title-wrapper">
        <div class="between-center gap-8 label-and-progress">
            <p class="count-label"><img class="card-icon" *ngIf="icon" [src]="'assets/icons/' + icon + '.svg'">{{ label }}</p>

            <div *ngIf="percentageProgress">
                <percentage-progress
                    [percentage]="percentageProgress.percentage"
                    [decreasing]="percentageProgress.decreasing"
                    [color]="percentageProgress.color"
                ></percentage-progress>
            </div>
        </div>

        <div class="tooltip-wrapper" *ngIf="tooltip" #tooltipWrapper>
            <img
                src="assets/svg/info.svg"
                class="info-icon"
                (mouseenter)="adjustTooltip(tooltipWrapper)"
            />
            <div class="tooltip-text" [ngClass]="tooltipPosition">
                {{ tooltip }}
            </div>
        </div>
    </div>
    <div class="between-center">
        <p class="count">{{ count }}</p>
        <p *ngIf="subtext" class="subtext">{{ subtext }}</p>
    </div>
    <ng-content></ng-content>
</div>
